import {Inject, Injectable} from '@angular/core';
import {
  RestService,
  RestSimpleResponseParser,
  RestYiiFilterService,
  RestYiiPagination,
  RestYiiSort
} from 'gelios-ng-admin-components';
import {HttpClient} from '@angular/common/http';
import {AcceptanceCertificateModel} from './acceptance-certificate.model';

@Injectable({
  providedIn: 'root'
})
export class AcceptanceCertificateService extends RestService <AcceptanceCertificateModel> {

  public get url(): string {
    return this.environmentApiBasepoint + 'acceptance-certificate';
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    this.fields = 'id,name,unit_type,is_used,date_create,project_id';
    this.expand = 'unitType,project_custom_name';
    this._filter.searchModelName = 'AcceptanceCertificateSearch';
  }
}
